import { useState } from 'react'
import { SearchBar } from './SearchBar'
import { MostLikedPost } from './MostLikedPost'
import { PostPreviewList } from './PostPreviewList'
import { MostCommentPost } from './MostCommentPost'
import { LatestPosts } from './LatestPosts'
import { RedDivider } from '../RedDivider'

export function PostList({
  posts,
  onRemovePost,
  onSearch,
  filterBy,
  authorMap,
}) {
  const [instantResults, setInstantResults] = useState([])

  const handleSearchInput = (value) => {
    if (value.length >= 3) {
      const filtered = posts.filter((post) =>
        post.title.toLowerCase().includes(value.toLowerCase())
      )
      setInstantResults(filtered)
    } else {
      setInstantResults([])
    }
  }

  const filteredPosts =
    instantResults.length > 0
      ? instantResults
      : filterBy.title || filterBy.tags.length > 0
      ? posts.filter((post) =>
          filterBy.tags.every((tag) => post.tags.includes(tag))
        )
      : posts

  const isSearching = filterBy.title || filterBy.tags.length > 0

  return (
    <section>
      <SearchBar
        onSearchInput={handleSearchInput}
        onSearch={onSearch}
        filterBy={filterBy}
        instantResults={instantResults}
      />
      <div className="container mx-auto p-4">
        {!isSearching && (
          <>
            <MostLikedPost posts={posts} authorMap={authorMap} />
            <MostCommentPost posts={posts} authorMap={authorMap} />
            <LatestPosts posts={posts} authorMap={authorMap} />
            <RedDivider />
          </>
        )}
        {filteredPosts.length === 0 ? (
          <p className="text-center">אין פוסטים זמינים</p>
        ) : (
          <PostPreviewList
            posts={filteredPosts}
            onRemovePost={onRemovePost}
            authorMap={authorMap}
          />
        )}
      </div>
    </section>
  )
}
